import React from 'react';
import AutocompleteGruppo from './autocompleteGruppo';

const PlayerData = ({ players, errors, onAddPlayer, onRemovePlayer, onUpdatePlayer, onPlayerCodeBlur, isEditMode = false, squadraPreiscrizione = false, censiti = true, gruppiScout = [], bloccato = false }) => {
  return (
    <div className="inscription-form-section">
      <div className="inscription-section-header">
        <i className="fas fa-user-friends"></i>
        <h2>Giocatori</h2>
        {isEditMode && (
          <span style={{marginLeft: 'auto', fontSize: '0.8rem', fontWeight: 'normal'}}>
            <i className="fas fa-edit"></i>
            {squadraPreiscrizione
              ? 'Tutti i campi modificabili per completare iscrizione'
              : 'Solo maglia e numero modificabili per esistenti'}
          </span>
        )}
      </div>
      <div className="inscription-section-content">
        <div className="inscription-players-header">
          <h3>Lista Giocatori ({players.length})</h3>
          <button
            type="button"
            className="inscription-add-player-btn"
            onClick={onAddPlayer}
            disabled={bloccato}
          >
            <i className="fas fa-plus"></i>
            Aggiungi Giocatore
          </button>
        </div>

        {errors.players && (
          <div className="inscription-error-message" style={{marginBottom: '1rem'}}>
            {errors.players}
          </div>
        )}

        {players.length === 0 ? (
          <div className="inscription-no-players">
            <i className="fas fa-user-plus"></i>
            <h3>Nessun giocatore aggiunto</h3>
            <p>Clicca su "Aggiungi Giocatore" per iniziare</p>
          </div>
        ) : (
          <div className="inscription-players-container">
            {/* Header delle colonne - Visibile solo su desktop */}
            <div className="inscription-players-table-header">
              <div className="inscription-header-number">#</div>
              <div className="inscription-header-fields">
                <div className="inscription-header-field">{censiti ? 'Codice *' : 'CF *'}</div>
                <div className="inscription-header-field">Nome *</div>
                <div className="inscription-header-field">Cognome *</div>
                <div className="inscription-header-field">Sesso *</div>
                <div className="inscription-header-field">Data Nascita *</div>
                <div className="inscription-header-field">Maglia {isEditMode && <span style={{color: '#3498db'}}>✓</span>}</div>
                <div className="inscription-header-field">N° * {isEditMode && <span style={{color: '#3498db'}}>✓</span>}</div>
                <div className="inscription-header-field">Gruppo *</div>
              </div>
              <div className="inscription-header-action">Azioni</div>
            </div>

            {/* Lista giocatori */}
            <div className="inscription-players-list">
              {players.map((player, index) => {
                const isExistingPlayer = isEditMode && !player.isNew && !squadraPreiscrizione;

                return (
                  <div key={player.id} className="inscription-player-row">
                    {/* Numero giocatore */}
                    <div className="inscription-player-number" style={{position: 'relative'}}>
                      {index + 1}
                      {isExistingPlayer && (
                        <div style={{
                          position: 'absolute',
                          top: '-8px',
                          right: '-8px',
                          width: '12px',
                          height: '12px',
                          backgroundColor: '#27ae60',
                          borderRadius: '50%',
                          border: '2px solid white',
                          fontSize: '6px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }} title="Giocatore esistente">
                          ✓
                        </div>
                      )}
                      {player.isNew && isEditMode && (
                        <div style={{
                          position: 'absolute',
                          top: '-8px',
                          right: '-8px',
                          width: '12px',
                          height: '12px',
                          backgroundColor: '#3498db',
                          borderRadius: '50%',
                          border: '2px solid white',
                          fontSize: '6px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'white'
                        }} title="Nuovo giocatore">
                          +
                        </div>
                      )}
                    </div>
                  
                    {/* Campi del giocatore */}
                    <div className="inscription-player-fields">
                      {censiti ? (
                        <div className={`inscription-form-group ${errors[`player_${player.id}_codice`] ? 'error' : ''}`}>
                          <input
                            type="text"
                            value={player.codice}
                            onChange={(e) => onUpdatePlayer(player.id, 'codice', e.target.value)}
                            onBlur={(e) => onPlayerCodeBlur && onPlayerCodeBlur(player.id, e.target.value)}
                            placeholder="Codice"
                            title="Codice Scout giocatore"
                            disabled={isExistingPlayer || bloccato}
                            style={isExistingPlayer ? {backgroundColor: '#f8f9fa', color: '#6c757d'} : {}}
                          />
                          {errors[`player_${player.id}_codice`] && (
                            <span className="inscription-error-message">{errors[`player_${player.id}_codice`]}</span>
                          )}
                        </div>
                      ) : (
                        <div className={`inscription-form-group ${errors[`player_${player.id}_codiceFiscale`] ? 'error' : ''}`}>
                          <input
                            type="text"
                            value={player.codiceFiscale || ''}
                            onChange={(e) => onUpdatePlayer(player.id, 'codiceFiscale', e.target.value.toUpperCase())}
                            placeholder="Codice Fiscale"
                            title="Codice Fiscale (16 caratteri)"
                            maxLength="16"
                            disabled={isExistingPlayer || bloccato}
                            style={isExistingPlayer ? {backgroundColor: '#f8f9fa', color: '#6c757d'} : {textTransform: 'uppercase'}}
                          />
                          {errors[`player_${player.id}_codiceFiscale`] && (
                            <span className="inscription-error-message">{errors[`player_${player.id}_codiceFiscale`]}</span>
                          )}
                        </div>
                      )}

                      <div className={`inscription-form-group ${errors[`player_${player.id}_nome`] ? 'error' : ''}`}>
                        <input
                          type="text"
                          value={player.nome}
                          onChange={(e) => onUpdatePlayer(player.id, 'nome', e.target.value)}
                          placeholder="Nome"
                          title="Nome giocatore"
                          disabled={isExistingPlayer || bloccato}
                          style={isExistingPlayer ? {backgroundColor: '#f8f9fa', color: '#6c757d'} : {}}
                        />
                        {errors[`player_${player.id}_nome`] && (
                          <span className="inscription-error-message">{errors[`player_${player.id}_nome`]}</span>
                        )}
                      </div>

                      <div className={`inscription-form-group ${errors[`player_${player.id}_cognome`] ? 'error' : ''}`}>
                        <input
                          type="text"
                          value={player.cognome}
                          onChange={(e) => onUpdatePlayer(player.id, 'cognome', e.target.value)}
                          placeholder="Cognome"
                          title="Cognome giocatore"
                          disabled={isExistingPlayer || bloccato}
                          style={isExistingPlayer ? {backgroundColor: '#f8f9fa', color: '#6c757d'} : {}}
                        />
                        {errors[`player_${player.id}_cognome`] && (
                          <span className="inscription-error-message">{errors[`player_${player.id}_cognome`]}</span>
                        )}
                      </div>

                      <div className={`inscription-form-group ${errors[`player_${player.id}_sesso`] ? 'error' : ''}`}>
                        <select
                          value={player.sesso}
                          onChange={(e) => onUpdatePlayer(player.id, 'sesso', e.target.value)}
                          title="Sesso"
                          disabled={isExistingPlayer || bloccato}
                          style={isExistingPlayer ? {backgroundColor: '#f8f9fa', color: '#6c757d'} : {}}
                        >
                          <option value="">-</option>
                          <option value="M">M</option>
                          <option value="F">F</option>
                        </select>
                        {errors[`player_${player.id}_sesso`] && (
                          <span className="inscription-error-message">{errors[`player_${player.id}_sesso`]}</span>
                        )}
                      </div>

                      <div className={`inscription-form-group ${errors[`player_${player.id}_dataNascita`] ? 'error' : ''}`}>
                        <input
                          type="date"
                          value={player.dataNascita}
                          onChange={(e) => onUpdatePlayer(player.id, 'dataNascita', e.target.value)}
                          title="Data di nascita"
                          disabled={isExistingPlayer || bloccato}
                          style={isExistingPlayer ? {backgroundColor: '#f8f9fa', color: '#6c757d'} : {}}
                        />
                        {errors[`player_${player.id}_dataNascita`] && (
                          <span className="inscription-error-message">{errors[`player_${player.id}_dataNascita`]}</span>
                        )}
                      </div>

                      <div className={`inscription-form-group ${errors[`player_${player.id}_maglia`] ? 'error' : ''}`}>
                        <input
                          type="text"
                          value={player.maglia}
                          onChange={(e) => onUpdatePlayer(player.id, 'maglia', e.target.value)}
                          placeholder="Nome maglia"
                          title="Nome squadra di appartenenza"
                          disabled={bloccato}
                          style={{borderColor: '#3498db', backgroundColor: '#f8fafe'}}
                        />
                        {errors[`player_${player.id}_maglia`] && (
                          <span className="inscription-error-message">{errors[`player_${player.id}_maglia`]}</span>
                        )}
                      </div>

                      <div className={`inscription-form-group ${errors[`player_${player.id}_numeroMaglia`] ? 'error' : ''}`}>
                        <select
                          value={player.numeroMaglia}
                          onChange={(e) => onUpdatePlayer(player.id, 'numeroMaglia', e.target.value)}
                          title="Numero di maglia"
                          disabled={bloccato}
                          style={{borderColor: '#3498db', backgroundColor: '#f8fafe'}}
                        >
                          <option value="">N</option>
                          {Array.from({ length: 100 }, (_, i) => i).map(num => (
                            <option key={num} value={num.toString()}>
                              {num}
                            </option>
                          ))}
                        </select>
                        {errors[`player_${player.id}_numeroMaglia`] && (
                          <span className="inscription-error-message">{errors[`player_${player.id}_numeroMaglia`]}</span>
                        )}
                      </div>

                       <div className={`inscription-form-group ${errors[`player_${player.id}_gruppo`] ? 'error' : ''}`}>
                        <AutocompleteGruppo
                          value={player.gruppo}
                          onChange={(text) => onUpdatePlayer(player.id, 'gruppo', text)}
                          normalizza={(text) => text.toLowerCase()}
                          gruppiScout={gruppiScout}
                          placeholder="Gruppo"
                          disabled={isExistingPlayer || bloccato}
                          style={isExistingPlayer ? {backgroundColor: '#f8f9fa', color: '#6c757d'} : {}}
                        />
                        {errors[`player_${player.id}_gruppo`] && (
                          <span className="inscription-error-message">{errors[`player_${player.id}_gruppo`]}</span>
                        )}
                      </div>
                    </div>
                  
                    {/* Bottone rimozione */}
                    <button
                      type="button"
                      className="inscription-remove-player-btn"
                      onClick={() => onRemovePlayer(player.id)}
                      title="Rimuovi giocatore"
                      disabled={bloccato}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PlayerData;